module.exports = __webpack_public_path__ + "static/media/beijing2.539db623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/imgForTest/beijing2.jpg
// module id = 1171
// module chunks = 0